export { FdcTag } from "./pages/fdcTag";
